import { unsecretize as originalUnsecretize } from '@gotombola/secretize';

export function unsecretize(data: string) {
    return originalUnsecretize(data);
}

export default unsecretize;
